import styled from 'styled-components'
import { colors, fontScope } from '../tokens'

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1000;
  background: rgba(10, 10, 10, 0.45);
`

export const Panel = styled.div`
  ${fontScope}
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1001;
  display: flex;
  flex-direction: column;
  max-height: 90vh;
  max-height: 90dvh;
  border-radius: 16px 16px 0 0;
  background: ${colors.white};
  box-shadow: 0 -8px 24px rgba(10, 10, 10, 0.16);
  outline: none;
`

export const Handle = styled.span`
  align-self: center;
  width: 40px;
  height: 4px;
  margin-top: 8px;
  border-radius: 2px;
  background: ${colors.checkboxBorder};
`

export const Top = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 8px 8px 16px;
  border-bottom: 1px solid ${colors.border};
`

export const Title = styled.h2`
  margin: 0;
  font-size: 18px;
  font-weight: 800;
  line-height: normal;
  color: ${colors.ink900};
`

export const Close = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border: 0;
  border-radius: 22px;
  background: transparent;
  cursor: pointer;

  &:focus-visible {
    outline: 2px solid ${colors.primary};
    outline-offset: -2px;
  }
`

export const Body = styled.div`
  flex: 1 1 auto;
  min-height: 0;
  padding: 16px;
  overflow-y: auto;
  overscroll-behavior: contain;
`

export const Footer = styled.div`
  display: flex;
  gap: 12px;
  padding: 12px 16px calc(12px + env(safe-area-inset-bottom, 0px));
  border-top: 1px solid ${colors.border};
`
